import { render, staticRenderFns } from "./batchManage.vue?vue&type=template&id=41f08f54"
import script from "./batchManage.vue?vue&type=script&lang=js"
export * from "./batchManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f08f54')) {
      api.createRecord('41f08f54', component.options)
    } else {
      api.reload('41f08f54', component.options)
    }
    module.hot.accept("./batchManage.vue?vue&type=template&id=41f08f54", function () {
      api.rerender('41f08f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/batch/batchManage.vue"
export default component.exports